//PRODUCTION URL
export const API_BASE_URL = "https://scanmogul.sml.com/lips-puma/api/";

//UAT URL
// export const API_BASE_URL =
//   "https://app-puma-test-001.azurewebsites.net/lips-puma/api/";
